import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getBudgetFailure, getBudgetSuccess } from '../../actions/CreateCampaignActions/getBudgetActions';

function* getBudget({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getBudget,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_BUDGET_SUCCESS status :", response.data.status);
        console.log("GET_BUDGET_SUCCESS data :", response.data.response);
        console.log("GET_BUDGET_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getBudgetSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_BUDGET_FAILURE status :", error?.response?.status);
        console.log("GET_BUDGET_FAILURE data:", error?.response?.data);
        console.log("GET_BUDGET_FAILURE error :", error);
        console.log('====================================');
        yield put(getBudgetFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getBudgetSaga() {
    yield takeLatest(actionTypes.GET_BUDGET_REQUEST, getBudget);
}

export default getBudgetSaga;
